import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
class StepLabel extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  render() {
    return (
      <div className="intro">
        <div className="step">
          <h2>{this.props.stepText}</h2>
        </div>
        <div className="text">
          <p>{this.props.instructionText}</p>
          <p><strong>{this.props.adTextHeader}</strong><br/>{this.props.adText}</p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(StepLabel);




